module.exports = __webpack_public_path__ + "static/img/far3.a5db2cb4.jpg";